import type {z} from "zod";
import {SetCustomerOfferChapterCommercialOptionsBody} from "@project/sdk/sales/zod";

export const setCustomerOfferChapterCommercialOptionsFormSchema =
  SetCustomerOfferChapterCommercialOptionsBody.strict();
export type SetCustomerOfferChapterCommercialOptionsFormPayload = z.output<
  typeof setCustomerOfferChapterCommercialOptionsFormSchema
>;
export const draftSetCustomerOfferChapterCommercialOptionsFormSchema =
  setCustomerOfferChapterCommercialOptionsFormSchema.partial();
export type DraftSetCustomerOfferChapterCommercialOptionsFormPayload = z.output<
  typeof draftSetCustomerOfferChapterCommercialOptionsFormSchema
>;
